import { CLIENTS } from "@/lib/site-data";

export default function TargetAudience() {
  return (
    <section
      id="clientes"
      data-testid="target-audience-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="block w-8 h-px bg-[#385723]" />
              <span className="overline">04 · Clientes</span>
            </div>
            <h2 className="heading-lg text-3xl sm:text-4xl lg:text-5xl text-white">
              Para quien
              <br />
              <span className="text-[#385723]">construimos.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 flex items-end">
            <p className="font-body text-base lg:text-lg text-white/70 leading-relaxed">
              Trabajamos con cuatro perfiles de cliente, cada uno con necesidades específicas y
              estándares no negociables. Adaptamos metodología, equipo y materiales a cada
              segmento.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5">
          {CLIENTS.map((c, i) => (
            <article
              key={i}
              data-testid={`client-card-${i}`}
              className="bg-luxe-black p-8 md:p-12 group hover:bg-[#0d0d0d] transition-colors relative"
            >
              <div className="flex items-start justify-between mb-8">
                <div className="w-14 h-14 border border-[#385723] flex items-center justify-center group-hover:bg-[#385723] transition-colors">
                  <c.Icon className="w-6 h-6 text-[#385723] group-hover:text-white transition-colors" strokeWidth={1.5} />
                </div>
                <span className="font-heading text-xs tracking-[0.3em] text-[#767171] uppercase">
                  Perfil 0{i + 1}
                </span>
              </div>
              <h3 className="heading-md text-xl lg:text-2xl text-white mb-4 group-hover:text-[#385723] transition-colors">
                {c.title}
              </h3>
              <p className="font-body text-white/65 leading-relaxed">
                {c.description}
              </p>
              <div className="absolute bottom-0 left-0 h-px w-0 bg-[#385723] group-hover:w-full transition-all duration-700" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
